import { render, staticRenderFns } from "./UploadImageDirect.vue?vue&type=template&id=0a8ae52a&scoped=true"
import script from "./UploadImageDirect.vue?vue&type=script&lang=js"
export * from "./UploadImageDirect.vue?vue&type=script&lang=js"
import style0 from "./UploadImageDirect.vue?vue&type=style&index=0&id=0a8ae52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ae52a",
  null
  
)

export default component.exports